<template>
  <div>
    <a-modal
      title="修改基本资料"
      :visible="visible"
      :maskClosable="false"
      @ok="handleOk"
      @cancel="handleCancel"
    >
      <a-form :form="form" class="form" style="margin-top: 35px;">
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="头像" style="margin-bottom: 20px;">
          <div style="height: 104px;overflow: hidden;">
            <upload ref="upload" :length="1" :imgs="imgs" @uploadSuccess="uploadSuccess" :cutImg="true" uploadTest="点击上传"></upload>
          </div>
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="账号">
          {{userInfo.account}}
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="昵称">
          <a-input placeholder="请输入昵称" v-decorator="['nickname', {initialValue: userInfo.nickname, rules: [{required: true, message: '请输入昵称'}]}]"/>
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="性别">
          <a-radio-group v-decorator="['sex', {initialValue: parseInt(userInfo.sex), rules: [{required: true, message: '请选择性别'}]}]">
            <a-radio :value="1">男</a-radio>
            <a-radio :value="2">女</a-radio>
            <a-radio :value="0">未知</a-radio>
          </a-radio-group>
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>
<script>
import store from '@/store'
import Upload from '@comm/upload/Upload'
import matchFun from '@comm/utils/matchFun'
import { mapState } from 'vuex'
export default {
  components: {
    Upload
  },
  data () {
    return {
      visible: false,
      confirmLoading: false,
      matchFun: matchFun,
      imgs: [],
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      form: this.$form.createForm(this)
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.user.userInfo
    })
  },
  methods: {
    show () {
      this.imgs = [this.matchFun.randomNumFile('avatar.jpg', this.userInfo.headSrc)]
      this.visible = true
    },
    handleOk (e) {
      this.form.validateFieldsAndScroll((err, values) => {
        if (!err) {
          var upData = {...values}
          if (this.imgs && this.imgs.length > 0) {
            upData.headSrc = this.imgs[0].url
          } else {
            this.$message.warn('请上传头像')
            return
          }
          this.$api.high.modification(upData).then(res => {
            if (res.status === 0) {
              this.userInfo.headSrc = upData.headSrc
              this.userInfo.nickname = upData.nickname
              this.userInfo.sex = upData.sex
              store.commit('user/USER_CHANGE_USER_INFO', this.userInfo)
              this.$message.success('保存成功')
              this.handleCancel()
            } else {
              this.$message.warn(res.msg)
            }
          }).catch(err => {
            console.log(err)
          })
        }
      })
    },
    handleCancel (e) {
      this.visible = false
    },
    uploadSuccess (e) {
      this.imgs = e
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/comm/components/center/modal/UpdateUserInfo.vue